<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      :title="oppAlertTitle"
      class="mb-12px"
    />
    <el-tabs v-model="tab" @tab-change="onTabChange">
      <el-tab-pane label="本所商机" name="mine" />
      <el-tab-pane :label="isSelfMode ? '待指派（本所）' : '可指派'" name="assignable" />
    </el-tabs>
    <el-form :inline="true" :model="query" class="mb-12px" @submit.prevent>
      <el-form-item label="商机号">
        <el-input v-model="query.oppNo" clearable class="!w-180px" />
      </el-form-item>
      <el-form-item v-if="tab === 'mine'" label="状态">
        <el-select v-model="query.status" clearable placeholder="全部" class="!w-140px">
          <el-option label="待分发" value="PENDING" />
          <el-option label="已接单" value="ASSIGNED" />
          <el-option label="服务中" value="SERVING" />
          <el-option label="已结案" value="CLOSED" />
          <el-option label="已取消" value="CANCELLED" />
          <el-option label="超时" value="TIMEOUT" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column prop="oppNo" label="商机号" min-width="140" />
      <el-table-column prop="userNickname" label="用户" width="100" show-overflow-tooltip />
      <el-table-column prop="userMobile" label="手机" width="110" />
      <el-table-column prop="causeType" label="案由" width="90" />
      <el-table-column prop="summary" label="摘要" min-width="140" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90" />
      <el-table-column label="接单律师" min-width="110" show-overflow-tooltip>
        <template #default="{ row }">
          {{ lawyerLabel(row) }}
        </template>
      </el-table-column>
      <el-table-column prop="firmRemark" label="所内备注" min-width="120" show-overflow-tooltip />
      <el-table-column prop="activatedAt" label="付款激活" width="150" />
      <el-table-column label="操作" :width="tab === 'assignable' ? 140 : 360" fixed="right">
        <template #default="{ row }">
          <el-button link @click="openDetail(row)">详情</el-button>
          <template v-if="tab === 'assignable'">
            <el-button link type="primary" @click="openAssign(row)">指派</el-button>
          </template>
          <template v-else>
            <el-button
              v-if="canReassign(row)"
              link
              type="primary"
              @click="openReassign(row)"
            >
              改派
            </el-button>
            <el-button
              v-if="row.status === 'ASSIGNED'"
              link
              type="success"
              @click="doServing(row)"
            >
              开始服务
            </el-button>
            <el-button
              v-if="row.status === 'SERVING' && row.activatedAt"
              link
              type="warning"
              @click="doClose(row)"
            >
              结案
            </el-button>
            <el-button
              v-if="canCancel(row)"
              link
              type="danger"
              @click="openCancel(row)"
            >
              取消
            </el-button>
            <el-button link @click="openRemark(row)">备注</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="getList"
    />

    <Dialog v-model="assignVisible" title="指派本所律师" width="420px">
      <el-form label-width="90px">
        <el-form-item label="商机">
          <span>{{ assignRow?.oppNo || assignRow?.id }}</span>
        </el-form-item>
        <el-form-item label="本所律师" required>
          <el-select v-model="assignLawyerId" filterable placeholder="选择可接单律师" class="!w-100%">
            <el-option
              v-for="l in lawyerOptions"
              :key="l.id"
              :label="`${l.name || '律师'}（#${l.id}）`"
              :value="l.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="assignVisible = false">取消</el-button>
        <el-button type="primary" :loading="assignSaving" @click="submitAssign">确定指派</el-button>
      </template>
    </Dialog>

    <Dialog v-model="reassignVisible" title="本所改派" width="440px">
      <el-form label-width="90px">
        <el-form-item label="商机">
          <span>{{ reassignRow?.oppNo || reassignRow?.id }}</span>
        </el-form-item>
        <el-form-item label="当前律师">
          <span>{{ lawyerLabel(reassignRow) }}</span>
        </el-form-item>
        <el-form-item label="改派给" required>
          <el-select v-model="reassignLawyerId" filterable placeholder="选择本所律师" class="!w-100%">
            <el-option
              v-for="l in lawyerOptions"
              :key="l.id"
              :label="`${l.name || '律师'}（#${l.id}）`"
              :value="l.id"
              :disabled="l.id === reassignRow?.grabbedLawyerId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="reassignRow?.status === 'SERVING' ? '原因*' : '原因'">
          <el-input
            v-model="reassignReason"
            type="textarea"
            :rows="2"
            :placeholder="reassignRow?.status === 'SERVING' ? '服务中改派须填写原因（≥5字）' : '可选'"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="reassignVisible = false">取消</el-button>
        <el-button type="primary" :loading="reassignSaving" @click="submitReassign">确定改派</el-button>
      </template>
    </Dialog>

    <Dialog v-model="cancelVisible" title="取消未付商机" width="420px">
      <el-form label-width="90px">
        <el-form-item label="商机">
          <span>{{ cancelRow?.oppNo || cancelRow?.id }}</span>
        </el-form-item>
        <el-form-item label="原因" required>
          <el-input v-model="cancelReason" type="textarea" :rows="2" placeholder="必填，写入所内备注" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="cancelVisible = false">返回</el-button>
        <el-button type="danger" :loading="cancelSaving" @click="submitCancel">确认取消</el-button>
      </template>
    </Dialog>

    <Dialog v-model="remarkVisible" title="所内备注" width="420px">
      <el-form label-width="90px">
        <el-form-item label="商机">
          <span>{{ remarkRow?.oppNo || remarkRow?.id }}</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="remarkText"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="仅本所/平台可见，不进客户 App"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="remarkVisible = false">取消</el-button>
        <el-button type="primary" :loading="remarkSaving" @click="submitRemark">保存</el-button>
      </template>
    </Dialog>

    <el-drawer v-model="detailVisible" title="商机详情" size="420px">
      <el-skeleton v-if="detailLoading" :rows="8" animated />
      <el-descriptions v-else-if="detail" :column="1" border>
        <el-descriptions-item label="商机号">{{ detail.oppNo || detail.id }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detail.status || '—' }}</el-descriptions-item>
        <el-descriptions-item label="用户">
          {{ detail.userNickname || '—' }} / {{ detail.userMobile || '—' }}
        </el-descriptions-item>
        <el-descriptions-item label="案由">{{ detail.causeType || '—' }}</el-descriptions-item>
        <el-descriptions-item label="地域">{{ detail.region || '—' }}</el-descriptions-item>
        <el-descriptions-item label="预算">{{ detail.budget ?? '—' }}</el-descriptions-item>
        <el-descriptions-item label="摘要">{{ detail.summary || '—' }}</el-descriptions-item>
        <el-descriptions-item label="分发模式">{{ detail.mode || '—' }}</el-descriptions-item>
        <el-descriptions-item label="接单律师">{{ lawyerLabel(detail) }}</el-descriptions-item>
        <el-descriptions-item label="意向律师">
          {{ detail.preferredLawyerId ? `#${detail.preferredLawyerId}` : '—' }}
        </el-descriptions-item>
        <el-descriptions-item label="案件律师">
          {{ detail.caseLawyerId ? `#${detail.caseLawyerId}` : '—' }}
        </el-descriptions-item>
        <el-descriptions-item label="付款激活">{{ detail.activatedAt || '未付' }}</el-descriptions-item>
        <el-descriptions-item label="所内备注">{{ detail.firmRemark || '—' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || '—' }}</el-descriptions-item>
      </el-descriptions>
    </el-drawer>
  </ContentWrap>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { FirmPortalApi, type FirmLawyerVO, type FirmOpportunityVO } from '@/api/firm/portal'
import { getFirmWorkbenchContext } from '@/api/firm/auth'

defineOptions({ name: 'FirmPortalOpportunity' })

const message = useMessage()
const route = useRoute()
const loading = ref(false)
const list = ref<FirmOpportunityVO[]>([])
const total = ref(0)
const tab = ref<'mine' | 'assignable'>('mine')
const isSelfMode = ref(false)
const oppAlertTitle = computed(() =>
  isSelfMode.value
    ? '本所商机可指派/改派/开始服务/结案/取消/备注；待指派仅本所未锁位商机（无公共抢单池）。不替代律师 App 办案材料。'
    : '本所商机可指派/改派/开始服务/结案/取消/备注；「可指派」含公共池与本所未锁位。不替代律师 App 抢单与办案材料。'
)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  oppNo: undefined as string | undefined,
  status: undefined as string | undefined
})

const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref<FirmOpportunityVO | null>(null)

const lawyerLabel = (row?: FirmOpportunityVO | null) => {
  if (!row?.grabbedLawyerId) return '—'
  return row.grabbedLawyerName
    ? `${row.grabbedLawyerName}（#${row.grabbedLawyerId}）`
    : `#${row.grabbedLawyerId}`
}

const lawyerOptions = ref<FirmLawyerVO[]>([])

const assignVisible = ref(false)
const assignSaving = ref(false)
const assignRow = ref<FirmOpportunityVO | null>(null)
const assignLawyerId = ref<number>()

const reassignVisible = ref(false)
const reassignSaving = ref(false)
const reassignRow = ref<FirmOpportunityVO | null>(null)
const reassignLawyerId = ref<number>()
const reassignReason = ref('')

const cancelVisible = ref(false)
const cancelSaving = ref(false)
const cancelRow = ref<FirmOpportunityVO | null>(null)
const cancelReason = ref('')

const remarkVisible = ref(false)
const remarkSaving = ref(false)
const remarkRow = ref<FirmOpportunityVO | null>(null)
const remarkText = ref('')

const canReassign = (row: FirmOpportunityVO) =>
  (row.status === 'ASSIGNED' || row.status === 'SERVING') &&
  !!row.grabbedLawyerId &&
  !row.preferredLawyerId

const canCancel = (row: FirmOpportunityVO) =>
  !row.activatedAt &&
  (row.status === 'PENDING' || row.status === 'TIMEOUT' || row.status === 'ASSIGNED')

const loadLawyers = async () => {
  lawyerOptions.value = (await FirmPortalApi.lawyerAssignableList()) || []
}

const getList = async () => {
  loading.value = true
  try {
    const data =
      tab.value === 'assignable'
        ? await FirmPortalApi.opportunityAssignablePage({
            pageNo: query.pageNo,
            pageSize: query.pageSize,
            oppNo: query.oppNo
          })
        : await FirmPortalApi.opportunityPage(query)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const onTabChange = () => {
  query.pageNo = 1
  getList()
}

const handleQuery = () => {
  query.pageNo = 1
  getList()
}

const resetQuery = () => {
  query.oppNo = undefined
  query.status = undefined
  handleQuery()
}

const openAssign = async (row: FirmOpportunityVO) => {
  assignRow.value = row
  assignLawyerId.value = undefined
  assignVisible.value = true
  await loadLawyers()
}

const submitAssign = async () => {
  if (!assignRow.value?.id || !assignLawyerId.value) {
    message.warning('请选择本所律师')
    return
  }
  assignSaving.value = true
  try {
    await FirmPortalApi.assignOpportunity({
      oppId: assignRow.value.id,
      lawyerId: assignLawyerId.value
    })
    message.success('已指派本所律师')
    assignVisible.value = false
    await getList()
  } finally {
    assignSaving.value = false
  }
}

const openReassign = async (row: FirmOpportunityVO) => {
  reassignRow.value = row
  reassignLawyerId.value = undefined
  reassignReason.value = ''
  reassignVisible.value = true
  await loadLawyers()
}

const submitReassign = async () => {
  if (!reassignRow.value?.id || !reassignLawyerId.value) {
    message.warning('请选择改派律师')
    return
  }
  if (reassignRow.value.status === 'SERVING' && reassignReason.value.trim().length < 5) {
    message.warning('服务中改派须填写原因（不少于 5 字）')
    return
  }
  reassignSaving.value = true
  try {
    await FirmPortalApi.reassignOpportunity({
      oppId: reassignRow.value.id,
      lawyerId: reassignLawyerId.value,
      reason: reassignReason.value.trim() || undefined
    })
    message.success('已改派')
    reassignVisible.value = false
    await getList()
  } finally {
    reassignSaving.value = false
  }
}

const doServing = async (row: FirmOpportunityVO) => {
  try {
    await message.confirm('确认将该商机标记为「服务中」？')
  } catch {
    return
  }
  await FirmPortalApi.servingOpportunity({ oppId: row.id })
  message.success('已开始服务')
  await getList()
}

const doClose = async (row: FirmOpportunityVO) => {
  try {
    await message.confirm('确认结案？将关闭商机进度（不替代律师 App 办案材料）。')
  } catch {
    return
  }
  await FirmPortalApi.closeOpportunity({ oppId: row.id })
  message.success('已结案')
  await getList()
}

const openCancel = (row: FirmOpportunityVO) => {
  cancelRow.value = row
  cancelReason.value = ''
  cancelVisible.value = true
}

const submitCancel = async () => {
  if (!cancelRow.value?.id || cancelReason.value.trim().length < 2) {
    message.warning('请填写取消原因')
    return
  }
  cancelSaving.value = true
  try {
    await FirmPortalApi.cancelOpportunity({
      oppId: cancelRow.value.id,
      reason: cancelReason.value.trim()
    })
    message.success('已取消')
    cancelVisible.value = false
    await getList()
  } finally {
    cancelSaving.value = false
  }
}

const openRemark = (row: FirmOpportunityVO) => {
  remarkRow.value = row
  remarkText.value = row.firmRemark || ''
  remarkVisible.value = true
}

const submitRemark = async () => {
  if (!remarkRow.value?.id) return
  remarkSaving.value = true
  try {
    await FirmPortalApi.updateFirmRemark({
      oppId: remarkRow.value.id,
      firmRemark: remarkText.value
    })
    message.success('备注已保存')
    remarkVisible.value = false
    await getList()
  } finally {
    remarkSaving.value = false
  }
}

const openDetail = async (row: FirmOpportunityVO) => {
  detailVisible.value = true
  detail.value = row
  detailLoading.value = true
  try {
    detail.value = (await FirmPortalApi.opportunityGet(row.id)) || row
  } finally {
    detailLoading.value = false
  }
}

onMounted(async () => {
  try {
    const ctx = await getFirmWorkbenchContext()
    isSelfMode.value = String(ctx?.bizMode || '').toUpperCase() === 'SELF'
  } catch {
    isSelfMode.value = false
  }
  if (route.query.tab === 'assignable') tab.value = 'assignable'
  if (typeof route.query.status === 'string' && route.query.status) {
    query.status = route.query.status
    tab.value = 'mine'
  }
  getList()
})
</script>
